import { ROOT_STATUS } from "."

export const STATUSES = {
  ...ROOT_STATUS,
  STATUS_CREATED : {
    key: 'STATUS_CREATED',
    value: 'Created',
    color: 'secondary',
    icon: '',
  },
  STATUS_AWAIT_PAYMENT : {
    key: 'STATUS_AWAIT_PAYMENT',
    value: 'Awaiting Payment',
    color: 'warning',
    icon: '',
  },
  STATUS_PAID : {
    key: 'STATUS_PAID',
    value: 'Paid',
    color: 'secondary',
    icon: '',
  },
  STATUS_PROCESSING : {
    key: 'STATUS_PROCESSING',
    value: 'Processing',
    color: 'secondary',
    icon: '',
  },
  STATUS_FAILED_IN_PROCESSING : {
    key: 'STATUS_FAILED_IN_PROCESSING',
    value: 'Failed in Processing',
    color: 'error',
    icon: '',
  },
  STATUS_ONGOING : {
    key: 'STATUS_ONGOING',
    value: 'Ongoing',
    color: 'primary',
    icon: '',
  },
  STATUS_COMPLETED : {
    key: 'STATUS_COMPLETED',
    value: 'Completed',
    color: 'success',
    icon: '',
  },
  STATUS_CANCEL : {
    key: 'STATUS_CANCEL',
    value: 'Cancel',
    color: 'error',
    icon: '',
  },
}

export const SERVICE_ITEMS = {
  "doctor-sign-off": {
    icon: "mdi-hospital-box",
  },
  "assessor-response": {
    icon: "mdi-chart-line",
  },
}